var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoohUser = function SvgDoohUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#689BFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.717 12.346a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.776 10c-5.376 0-9.732 4.352-9.732 9.723 0 5.37 4.356 9.722 9.732 9.722s9.732-4.352 9.732-9.722S26.152 10 20.776 10m.036 14.79c-2.838 0-5.137-2.318-5.137-5.18s2.3-5.181 5.137-5.181 5.136 2.319 5.136 5.181-2.299 5.18-5.136 5.18",
    opacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.672 10.012H11v19.447h4.672z"
  })));
};
export default SvgDoohUser;